import { createComponent } from '@/helpers/alpine';

const AudioPlayer = createComponent(() => ({
    isPlaying: false,
    isMuted: false,
    duration: 0,
    currentTime: 0,
    isLoaded: false,

    init() {
        const audioPlayer = this.$refs.audio as HTMLAudioElement;

        audioPlayer.addEventListener('loadedmetadata', () => {
            if (isFinite(audioPlayer.duration)) {
                this.duration = audioPlayer.duration;
            } else {
                this.duration = 0;
            }
            this.isLoaded = true;
        });

        audioPlayer.addEventListener('timeupdate', () => {
            this.currentTime = audioPlayer.currentTime;
        });

        audioPlayer.addEventListener('ended', () => {
            audioPlayer.pause();
            audioPlayer.currentTime = 0;
            this.isPlaying = false;
        });

        audioPlayer.load();
    },

    togglePlay() {
        const audioPlayer = this.$refs.audio as HTMLAudioElement;

        if (audioPlayer.paused) {
            audioPlayer.play();
            this.isPlaying = true;
        } else {
            audioPlayer.pause();
            this.isPlaying = false;
        }
    },

    toggleSound() {
        const audioPlayer = this.$refs.audio as HTMLAudioElement;

        audioPlayer.muted = !audioPlayer.muted;
        this.isMuted = audioPlayer.muted;
    },

    formatTime(t: number) {
        if (!isFinite(t) || t < 0) return '0:00';
        const m = Math.floor(t / 60);
        const s = Math.floor(t % 60);
        return `${m}:${s.toString().padStart(2, '0')}`;
    },
}));

export { AudioPlayer };
